// extracted by mini-css-extract-plugin
export var content = "_s7-1";
export var wrapper = "_s7-0";